import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const TESTIMONIAL_ITEM_SCHEMA = [
  { key: "avatar", label: "Avatar Image", type: "image" as const },
  { key: "name", label: "Name", type: "string" as const },
  { key: "designation", label: "Designation", type: "string" as const },
  { key: "review", label: "Review Text", type: "text" as const },
  { key: "rating", label: "Rating (1–5)", type: "number" as const, default: 5 },
];

export const schema: ComponentSchema = {
  type: "testimonials",
  label: "Testimonials",
  description: "Customer reviews and social proof section.",
  supportedPages: ["home", "shop"],
  variants: [
    {
      id: "v1",
      label: "V1 — Centered Slider",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "What Our Customers Say" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: TESTIMONIAL_ITEM_SCHEMA },
      ],
    },
    {
      id: "v2",
      label: "V2 — Card Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Customer Reviews" },
        { key: "items", label: "Testimonials", type: "array", itemSchema: TESTIMONIAL_ITEM_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
